import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  const [first, ...rest] = (settings.team_name || "Voltage Vipers").split(" ");
  const second = rest.join(" ");
  const teamNum = settings.team_number ? `#${settings.team_number}` : "#COMING-SOON";

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-voltage-blue/40 bg-voltage-bg mt-20"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <div className="font-display font-black text-2xl tracking-wider uppercase">
            <span className="text-white">{first}</span>{" "}
            {second && <span className="text-voltage-yellow">{second}</span>}
          </div>
          <p className="text-voltage-muted text-sm mt-3 max-w-xs">
            FTC Robotics — engineering the future, one bolt at a time.
          </p>
        </div>
        <div>
          <div className="overline mb-3">Navigate</div>
          <ul className="space-y-2 text-sm text-voltage-muted">
            <li><a href="#about" className="hover:text-voltage-yellow">About</a></li>
            <li><a href="#team" className="hover:text-voltage-yellow">Team</a></li>
            <li><a href="#robots" className="hover:text-voltage-yellow">Robots</a></li>
            <li><a href="#outreach" className="hover:text-voltage-yellow">Outreach</a></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Admin</div>
          <Link
            to="/admin/login"
            data-testid="footer-admin-link"
            className="text-sm text-voltage-muted hover:text-voltage-yellow"
          >
            Admin Console →
          </Link>
        </div>
      </div>
      <div className="border-t border-voltage-blue/20 py-4 text-center text-xs text-voltage-muted font-mono tracking-wider">
        © {new Date().getFullYear()} {settings.team_name?.toUpperCase() || "VOLTAGE VIPERS"} · FTC TEAM {teamNum}
      </div>
    </footer>
  );
}
